import listStores from './list';

export default listStores;
